import React, { useState } from 'react'
import styled from 'styled-components'
import { Wrapper, H, P, Image } from '@farewill/ui'
import { BORDER, FONT, GTR } from '@farewill/ui/tokens'
import { screenMin } from '@farewill/ui/helpers/responsive'
import MediaModal from 'components/Modal/MediaModal'

const StyledLogo = styled(Image)`
  width: 200px;
  object-fit: contain;
  padding-top: ${GTR.M};
  ${screenMin.l`
    padding-top: 0;
    width: 300px;
  `}

  ${screenMin.xl`
    width: 350px;
  `}
`

const StyledContentWrapper = styled(Wrapper)`
  gap: ${GTR.M};
`

const StyledWrapper = styled(Wrapper)`
  display: flex;
  flex-direction: column;
  ${screenMin.l`
    flex-direction: row;
    gap: ${GTR.XXL};
  `}
  ${screenMin.xl`

    align-items: center;
  `}
`

const StyledLogoWrapper = styled(Wrapper)`
  text-align: center;
`

const StyledVideoThumbnailImage = styled(Image)`
  max-width: 100%;
  aspect-ratio: 16/10;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  border-radius: ${BORDER.RADIUS.L};
  ${screenMin.s`
    margin-bottom: ${GTR.M};
  `}
`

const StyledVideoThumbnail = styled(Wrapper)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  ${screenMin.m`
    order: 1;
  `}
  ${screenMin.l`
    min-width: 350px;
    order: 0;
  `}
  ${screenMin.xl`
    min-width: 500px;
  `}
  &:hover {
    ${StyledVideoThumbnailImage} {
      transform: scale(1.02);
      filter: brightness(0.85);
    }
  }
`

const StyledVideoHeading = styled(H)`
  font-size: 20px;
  font-weight: ${FONT.WEIGHT.BOLD};
  ${screenMin.m`
    font-size: ${FONT.SIZE.XL};
    font-weight: ${FONT.WEIGHT.MEDIUM};
    `}
`

const StyledVideoDescription = styled(P)`
  font-size: ${FONT.SIZE.M};
  ${screenMin.m`
    font-size: ${FONT.SIZE.L};
    `}
`

const StyledVideoDecorativeTitle = styled(Image)`
  display: none;
  margin: 0 auto;
  ${screenMin.s`
  display: block;
`}
`

const StyledVideoSectionWrapper = styled(Wrapper)`
  margin-top: ${GTR.M};
  display: flex;
  flex-direction: column;
  gap: ${GTR.M};
  ${screenMin.l`
    margin-top: ${GTR.XL};
    flex-direction: row;
    align-items: center;
    gap: ${GTR.XXL};
  `}
`

function About(): React.ReactElement {
  const [videoModalOpen, setVideoModalOpen] = useState(false)
  return (
    <Wrapper container>
      <StyledWrapper>
        <StyledContentWrapper>
          <H size="L" decorative>
            Together we are beating cancer
          </H>
          <StyledVideoDescription>
            Cancer Research UK exist to beat cancer. They are the world’s
            leading cancer charity, dedicated to saving and improving lives with
            their research.
          </StyledVideoDescription>
        </StyledContentWrapper>

        <StyledLogoWrapper>
          <StyledLogo
            path="com-assets/bespoke-journey-cruk/logo"
            ext="png"
            width={600}
            alt="Cancer Research UK"
          />
        </StyledLogoWrapper>
      </StyledWrapper>

      <StyledVideoSectionWrapper>
        <StyledVideoThumbnail onClick={() => setVideoModalOpen(true)}>
          <StyledVideoThumbnailImage
            path="com-assets/bespoke-journey-cruk/cruk-video-thumbnail"
            ext="jpg"
            width={1024}
            alt="Cancer Research UK"
          />
          <StyledVideoDecorativeTitle
            path="com-assets/bespoke-journey-cruk/video-decorative-title"
            ext="svg"
            alt="The impact of leaving a gift in your will"
            width={319}
          />
        </StyledVideoThumbnail>

        <Wrapper>
          <StyledVideoHeading>
            Gifts of every size can help power progress
          </StyledVideoHeading>
          <StyledVideoDescription>
            Your gift can help Cancer Research UK bring about a world where
            everybody lives longer, better lives, free from the fear of cancer.
            It helps to carry out research into more than 200 types of cancer,
            like Leukaemia, which Doreen, pictured below, was diagnosed with in
            1998.
          </StyledVideoDescription>
        </Wrapper>
      </StyledVideoSectionWrapper>
      {videoModalOpen && (
        <MediaModal close={() => setVideoModalOpen(false)}>
          <iframe
            title="vimeo-player"
            src="https://player.vimeo.com/video/1169861860?h=b464975b23&autoplay=1&vimeo_logo=0&muted=0"
            width="640"
            height="360"
            frameBorder="0"
            referrerPolicy="strict-origin-when-cross-origin"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            allowFullScreen
          />
        </MediaModal>
      )}
    </Wrapper>
  )
}

export default About
